import React from "react";
import AudioControl from "./AudioControl";
import { useSettings } from "../providers/SettingsContext";
import { useMessageActions } from "../hooks/useMessageActions";

interface MessageControlsProps {
  audioBlob: Blob | null;
  isLoadingAudio?: boolean;
  queryId?: string;
  autoPlay?: boolean;
  isFlagged?: boolean;
}

const MessageControls: React.FC<MessageControlsProps> = ({
  audioBlob,
  isLoadingAudio = false,
  queryId,
  autoPlay = false,
  isFlagged = false,
}) => {
  const { settings } = useSettings();
  const { onFlagClick } = useMessageActions();

  const handleFlagClick = () => {
    if (queryId) {
      onFlagClick(queryId);
    }
  };

  // Calculate button size based on text size setting
  const iconSize = Math.max(16, Math.min(30, settings.textSize * 0.8));
  const buttonSize = Math.max(32, Math.min(48, settings.textSize * 2));

  return (
    <div className="flex flex-col items-center gap-1.5 sm:gap-2 mt-1 sm:mt-2">
      {(audioBlob || isLoadingAudio) && (
        <AudioControl
          id={queryId || "unknown"}
          audioBlob={audioBlob}
          isLoading={isLoadingAudio}
          autoPlay={autoPlay}
        />
      )}
      {queryId && (
        <button
          className={`rounded-full border-none bg-transparent cursor-pointer flex items-center justify-center p-1 transition-all duration-300 ${
            isFlagged
              ? "text-red-600 hover:bg-red-100"
              : "text-black hover:bg-gray-400"
          }`}
          style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
          onClick={handleFlagClick}
          disabled={isFlagged}
          title={isFlagged ? "Message flagged" : "Flag this message"}
        >
          <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 3 L4 17 M4 3 L14 5 L14 11 L4 9"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={isFlagged ? "currentColor" : "none"}
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default MessageControls;
